module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Serviços "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.pagination.totalItems))])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm ",
    attrs: {
      "to": {
        name: 'policiacivil.processo.servicos.novo'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                    Novo Serviço\n                  ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 m-b-xs"
  }, [_c('div', {
    staticClass: "btn-group dropdown"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "disabled": "",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    Exportar\n                    "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Dropdown link")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "aria-disabled": "true"
    },
    on: {
      "click": function($event) {
        return _vm.deletar()
      }
    }
  }, [_vm._v("Deletar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }, function($event) {
        return _vm.checkAll(_vm.data)
      }]
    }
  }), _c('i')])]), _vm._v(" "), _c('th', [_vm._v("Serviço")]), _vm._v(" "), _c('th', [_vm._v("Ativo")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredData), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "post[]",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, item.id) > -1 : (item.selected)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.lazyCheck(item)
        },
        "change": function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('i')])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(item.id)
        }
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link "
    }, [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(item.id)
        }
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link ",
      class: {
        'text-danger': !item.ativo, 'text-success': item.ativo
      }
    }, [_vm._v("\n                      " + _vm._s(item.ativo ? 'Ativo' : 'Inativo') + "\n                    ")])])])
  }), _vm._v(" "), (!_vm.filteredData || _vm.filteredData.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm "
  }, [_vm._v(_vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b51d968","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/processo/servicos/components/ServicoLista.vue
// module id = 1810
// module chunks = 17